import React from 'react';
import CrudManager from '../../components/admin/CrudManager';
import { getBooks, createBook, updateBook, deleteBook } from '../../utils/api';

const fields = [
  { name: 'title', label: 'Title (Hindi)', type: 'text', required: true, placeholder: 'राष्ट्रीय स्वयंसेवक संघ...' },
  { name: 'titleEnglish', label: 'Title (English)', type: 'text' },
  { name: 'subtitle', label: 'Subtitle / Tagline', type: 'textarea', rows: 2 },
  { name: 'description', label: 'Description', type: 'textarea', required: true },
  { name: 'coverImage', label: 'Cover Image', type: 'image' },
  { name: 'price', label: 'Price', type: 'text', placeholder: '₹350' },
  { name: 'pages', label: 'Pages', type: 'number' },
  { name: 'language', label: 'Language', type: 'text', placeholder: 'Hindi' },
  { name: 'publisher', label: 'Publisher', type: 'text' },
  { name: 'publishDate', label: 'Publish Year', type: 'text' },
  { name: 'isbn', label: 'ISBN', type: 'text' },
  { name: 'amazonLink', label: 'Amazon Link', type: 'text' },
  { name: 'flipkartLink', label: 'Flipkart Link', type: 'text' },
  { name: 'garudaLink', label: 'Garuda Prakashan Link', type: 'text' },
  { name: 'highlights', label: 'Key Highlights', type: 'list', placeholder: 'Enter a highlight' },
  { name: 'tableOfContents', label: 'Table of Contents', type: 'list', placeholder: 'Chapter name' },
  { name: 'benefits', label: 'Benefits of Reading', type: 'list', placeholder: 'Enter a benefit' },
];

export default function AdminBooks() {
  return (
    <CrudManager
      title="Books"
      subtitle="Manage your published books"
      fields={fields}
      fetchFn={getBooks}
      createFn={createBook}
      updateFn={updateBook}
      deleteFn={deleteBook}
      cardRenderer={(item) => (
        <div>
          {item.coverImage && <img src={item.coverImage} alt={item.title} className="w-full h-40 object-cover" />}
          <div className="p-4">
            <h3 className="font-bold text-slate-900 line-clamp-2" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>{item.title}</h3>
            <p className="text-sm text-orange-600 mt-1">{item.price}</p>
          </div>
        </div>
      )}
    />
  );
}
